import { render, staticRenderFns } from "./ShortcutsModal.vue?vue&type=template&id=b11617aa&"
import script from "./ShortcutsModal.vue?vue&type=script&lang=js&"
export * from "./ShortcutsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports